import React, { useEffect } from "react";
import LocaleRoutes from "./routes";
import { useLocation } from "react-router";
import { IntlProvider } from 'react-intl';
import { Helmet } from "react-helmet-async";
import { defaultLocale, useLocaleContext } from "@ct-react/locale";
import { getIntlMessages } from "./i18n";
import CmsProvider from "./contexts/cms";
import { ScrollLockProvider } from "./contexts/lockScroll";
import { MenuProvider } from "./contexts/menu";
import { SearchProvider } from "./contexts/search";
import Promo from "./layout/menu/promo";
import Menu from "./layout/menu/menu";
import Footer from "./layout/footer/footer";
import { RGPDConsentProcessor, RGPDConsentProvider, SearchBar } from "./bundles/client-only-ui";
import "./styles/global.scss";

const cookieConsentOptions = { consentCookieAttributes: { expires: 180 } };

const App =( ) => {

  const { locale } = useLocaleContext();
  const location = useLocation();
  const messages = getIntlMessages(locale);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [ location ]);

  const content = (
    <IntlProvider locale={locale.code}
                  defaultLocale={defaultLocale.code}
                  messages={messages}
                  onError={() => void 0}>
            <Helmet>
              <html lang={locale.code} />
              <meta property="og:locale" content={locale.code} />
              <meta property="og:type" content="website" />
            </Helmet>
            <CmsProvider>
              <ScrollLockProvider>
                <MenuProvider state={false}>
                  <Menu />
                </MenuProvider>
                <SearchProvider>
                  <SearchBar />
                  <main>
                    <LocaleRoutes />
                  </main>
                </SearchProvider>
                <Footer />
              </ScrollLockProvider>
            </CmsProvider>
    </IntlProvider>
  );

  return(
    <RGPDConsentProvider useCookieConsentHooksOptions={cookieConsentOptions}
                         fallback={content}>
      <RGPDConsentProcessor />
      {content}
    </RGPDConsentProvider>);

};

export default App;
